export default __webpack_public_path__ + "static/0224-ea5faeb78f3532d1da848b4cf2328c69.png";